module.exports = __webpack_public_path__ + "assets/img/mecha-btn-fe822b52.png";